import { Navigate, Outlet } from 'react-router-dom';

import { LoadingState } from '../components/index.js';
import { useCurrentUser } from '../lib/auth.js';

/** Redirects an already-authenticated visitor away from register/login (UX only, see `ProtectedRoute`). */
export function PublicOnlyRoute() {
  const { data: user, isPending } = useCurrentUser();

  if (isPending) {
    return <LoadingState label="Checking your session…" />;
  }

  if (user) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}
